// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* root variables */
:root {
  --main-content-x-offset: 240px;
  --navbar-height: 52px;
  --width-sidebar: 240px;
}

/* root variables responsive */
@media (min-width: 0) {
  :root {
    --header-height: 50px;
  }
}

@media (min-width: 768px) {
  :root {
    --header-height: 70px;
  }
}

/* Style layout microfrontend */

.single-spa-container {
  height: 100%;
}

/*Without navbar*/
#single-spa-application\\:\\@pt\\/vue-manage,
#single-spa-application\\:\\@pt\\/vue-plans,
#single-spa-application\\:\\@pt\\/vue-agroanalysis,
#single-spa-application\\:\\@pt\\/vue-analysis {
  height: 100%;
}

/*With navbar */
#single-spa-application\\:\\@pt\\/vue-meteo,
#single-spa-application\\:\\@pt\\/vue-pest-management,
#single-spa-application\\:\\@pt\\/vue-finished-crops,
#single-spa-application\\:\\@pt\\/vue-dashboard {
  min-height: 100%;
  padding: 2rem 0.6rem 1rem;
}

/*With navbar and toolbar*/
#single-spa-application\\:\\@pt\\/vue-irrigation,
#single-spa-application\\:\\@pt\\/vue-fertilization {
  height: calc(100% - (var(--header-height) + var(--navbar-height)));
}

#single-spa-application\\:\\@pt\\/vue-navigation {
  grid-row: 1 / 1;
  grid-column: 1 / 3;
}

#single-spa-application\\:\\@pt\\/vue-navigation {
  padding-top: var(--header-height);
}

.main-content {
  height: calc(100% - (var(--header-height)));
}

#single-spa-application\\:\\@pt\\/vue-finished-crops,
#single-spa-application\\:\\@pt\\/vue-pest-management {
  background-color: white;
}

@media screen and (min-width: 1024px) {
  .main-content {
    height: calc(100% - (var(--header-height) + var(--navbar-height)));
  }
}
@media screen and (max-width: 1024px) {
  form {
    padding-bottom: 60px;
  }
}

#nav {
  width: 100%;
}
.layout {
  display: block;
}
.wrapper-with-navbar {
  height: 100%;
}
.main,
body {
  position: relative;
  background-color: #e5e5e5;
}
@media (min-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: var(--main-content-x-offset) calc(100% - var(--main-content-x-offset));
  }
}
@media (min-width: 1024px) {
  [id*='navigation'] {
    height: 100%;
  }
}

@media (min-width: 1024px) {
  .main-content {
    height: 100%;
    align-self: flex-start;
    grid-row: 1 / 1;
    grid-column: 2 / 2;
  }

  #nav {
    width: calc(100% - var(--width-sidebar));
    margin-left: auto;
  }

  /*Without navbar*/
  #single-spa-application\\:\\@pt\\/vue-agroanalysis,
  #single-spa-application\\:\\@pt\\/vue-manage,
  #single-spa-application\\:\\@pt\\/vue-plans,
  #single-spa-application\\:\\@pt\\/vue-analysis {
    position: relative;
    margin-top: var(--header-height);
    height: calc(100% - var(--header-height));
  }

  /*With navbar */

  #single-spa-application\\:\\@pt\\/vue-meteo,
  #single-spa-application\\:\\@pt\\/vue-pest-management,
  #single-spa-application\\:\\@pt\\/vue-finished-crops,
  #single-spa-application\\:\\@pt\\/vue-dashboard {
    position: relative;
    margin-top: calc((var(--header-height)));
    height: calc(100% - (var(--header-height)));
    padding: 4rem 0.6rem 1rem;
  }

  /*With navbar and toolbar*/

  #single-spa-application\\:\\@pt\\/vue-irrigation,
  #single-spa-application\\:\\@pt\\/vue-fertilization {
    margin-top: calc(var(--header-height) + var(--navbar-height));
    height: calc(100% - (var(--header-height) + var(--navbar-height)));
  }
}

.content {
  width: 100%;
}

.pt-scroll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px white;
}
.pt-scroll::-webkit-scrollbar {
  background-color: #fcf8f3;
  height: 5px;
  width: 5px;
  border-radius: 10px;
}
.pt-scroll::-webkit-scrollbar-thumb {
  background-color: #109dc2;
  border-radius: 10px;
}

.hide-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
.hide-scroll::-webkit-scrollbar-thumb {
  background: transparent;
}

.no-scroll {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/microfrontend-layout.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;;;;EAIE,YAAY;AACd;;AAEA,eAAe;AACf;;;;EAIE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;;EAEE,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE;IACE,kEAAkE;EACpE;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;IACE,aAAa;IACb,6FAA6F;EAC/F;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;;;;IAIE,kBAAkB;IAClB,gCAAgC;IAChC,yCAAyC;EAC3C;;EAEA,eAAe;;EAEf;;;;IAIE,kBAAkB;IAClB,wCAAwC;IACxC,2CAA2C;IAC3C,yBAAyB;EAC3B;;EAEA,0BAA0B;;EAE1B;;IAEE,6DAA6D;IAC7D,kEAAkE;EACpE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* root variables */\n:root {\n  --main-content-x-offset: 240px;\n  --navbar-height: 52px;\n  --width-sidebar: 240px;\n}\n\n/* root variables responsive */\n@media (min-width: 0) {\n  :root {\n    --header-height: 50px;\n  }\n}\n\n@media (min-width: 768px) {\n  :root {\n    --header-height: 70px;\n  }\n}\n\n/* Style layout microfrontend */\n\n.single-spa-container {\n  height: 100%;\n}\n\n/*Without navbar*/\n#single-spa-application\\:\\@pt\\/vue-manage,\n#single-spa-application\\:\\@pt\\/vue-plans,\n#single-spa-application\\:\\@pt\\/vue-agroanalysis,\n#single-spa-application\\:\\@pt\\/vue-analysis {\n  height: 100%;\n}\n\n/*With navbar */\n#single-spa-application\\:\\@pt\\/vue-meteo,\n#single-spa-application\\:\\@pt\\/vue-pest-management,\n#single-spa-application\\:\\@pt\\/vue-finished-crops,\n#single-spa-application\\:\\@pt\\/vue-dashboard {\n  min-height: 100%;\n  padding: 2rem 0.6rem 1rem;\n}\n\n/*With navbar and toolbar*/\n#single-spa-application\\:\\@pt\\/vue-irrigation,\n#single-spa-application\\:\\@pt\\/vue-fertilization {\n  height: calc(100% - (var(--header-height) + var(--navbar-height)));\n}\n\n#single-spa-application\\:\\@pt\\/vue-navigation {\n  grid-row: 1 / 1;\n  grid-column: 1 / 3;\n}\n\n#single-spa-application\\:\\@pt\\/vue-navigation {\n  padding-top: var(--header-height);\n}\n\n.main-content {\n  height: calc(100% - (var(--header-height)));\n}\n\n#single-spa-application\\:\\@pt\\/vue-finished-crops,\n#single-spa-application\\:\\@pt\\/vue-pest-management {\n  background-color: white;\n}\n\n@media screen and (min-width: 1024px) {\n  .main-content {\n    height: calc(100% - (var(--header-height) + var(--navbar-height)));\n  }\n}\n@media screen and (max-width: 1024px) {\n  form {\n    padding-bottom: 60px;\n  }\n}\n\n#nav {\n  width: 100%;\n}\n.layout {\n  display: block;\n}\n.wrapper-with-navbar {\n  height: 100%;\n}\n.main,\nbody {\n  position: relative;\n  background-color: #e5e5e5;\n}\n@media (min-width: 1024px) {\n  .main {\n    display: grid;\n    grid-template-columns: var(--main-content-x-offset) calc(100% - var(--main-content-x-offset));\n  }\n}\n@media (min-width: 1024px) {\n  [id*='navigation'] {\n    height: 100%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .main-content {\n    height: 100%;\n    align-self: flex-start;\n    grid-row: 1 / 1;\n    grid-column: 2 / 2;\n  }\n\n  #nav {\n    width: calc(100% - var(--width-sidebar));\n    margin-left: auto;\n  }\n\n  /*Without navbar*/\n  #single-spa-application\\:\\@pt\\/vue-agroanalysis,\n  #single-spa-application\\:\\@pt\\/vue-manage,\n  #single-spa-application\\:\\@pt\\/vue-plans,\n  #single-spa-application\\:\\@pt\\/vue-analysis {\n    position: relative;\n    margin-top: var(--header-height);\n    height: calc(100% - var(--header-height));\n  }\n\n  /*With navbar */\n\n  #single-spa-application\\:\\@pt\\/vue-meteo,\n  #single-spa-application\\:\\@pt\\/vue-pest-management,\n  #single-spa-application\\:\\@pt\\/vue-finished-crops,\n  #single-spa-application\\:\\@pt\\/vue-dashboard {\n    position: relative;\n    margin-top: calc((var(--header-height)));\n    height: calc(100% - (var(--header-height)));\n    padding: 4rem 0.6rem 1rem;\n  }\n\n  /*With navbar and toolbar*/\n\n  #single-spa-application\\:\\@pt\\/vue-irrigation,\n  #single-spa-application\\:\\@pt\\/vue-fertilization {\n    margin-top: calc(var(--header-height) + var(--navbar-height));\n    height: calc(100% - (var(--header-height) + var(--navbar-height)));\n  }\n}\n\n.content {\n  width: 100%;\n}\n\n.pt-scroll::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 3px white;\n}\n.pt-scroll::-webkit-scrollbar {\n  background-color: #fcf8f3;\n  height: 5px;\n  width: 5px;\n  border-radius: 10px;\n}\n.pt-scroll::-webkit-scrollbar-thumb {\n  background-color: #109dc2;\n  border-radius: 10px;\n}\n\n.hide-scroll::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n  background: transparent;\n}\n.hide-scroll::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.no-scroll {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
